module.exports = {"html":"http://www.w3.org/1999/xhtml","mathml":"http://www.w3.org/1998/Math/MathML","svg":"http://www.w3.org/2000/svg","xlink":"http://www.w3.org/1999/xlink","xml":"http://www.w3.org/XML/1998/namespace","xmlns":"http://www.w3.org/2000/xmlns/"}


//////////////////
// WEBPACK FOOTER
// ./~/web-namespaces/index.json
// module id = 269
// module chunks = 33019919093843 87034247430840 144482056661899